/**
 * PageTransition Component
 * 
 * Wraps page content with smooth Framer Motion enter/exit animations.
 * Use this to wrap page content for consistent transitions.
 */

import React from 'react';
import { motion } from 'framer-motion';

// Animation variants matching the site's design language
const pageVariants = {
    initial: {
        opacity: 0,
        y: 12
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.25,
            ease: [0.4, 0, 0.2, 1] // Custom easing matching ChatPopup
        }
    },
    exit: {
        opacity: 0,
        y: -8,
        transition: {
            duration: 0.15,
            ease: [0.4, 0, 1, 1]
        }
    }
};

function PageTransition({ children, className = '' }) {
    return (
        <motion.div
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageVariants}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export default PageTransition;
